export const en = {
  language: "EN",
  currency: "$",
  actions: "Actions",
  add: "Add",
  apply: "Apply",
  apps: "Applications",
  attach: "Attach",
  cancel: "Cancel",
  clear: "Clear",
  close: "Close",
  column: "Column",
  completed: "Completed",
  continue: "Continue",
  create: "Create",
  delete: "Delete",
  disabled: "Disabled",
  edit: "Edit",
  enabled: "Enabled",
  error: "Error",
  expand: "Expand",
  export: "Export",
  filter: "Filter",
  filterNoun: "Filter",
  finish: "Finish",
  help: "Help",
  subscribeNow: "Subscribe Now",
  import: "Import",
  indicators: "Indicators",
  link: "Link",
  loading: "Loading",
  logout: "Logout",
  measurement: "Measurement",
  name: "Name",
  next: "Next",
  optional: "Optional",
  or: "or",
  password: "Password",
  profile: "Profile",
  readjustiment: "Reajuste",
  register: "Register",
  reset: "Reset",
  resetPassword: "Reset password",
  changePassword: "Change password",
  returnHome: "Return to Homepage",
  returnPreviousPage: "Return to previous page",
  save: "Save",
  search: "Search",
  select: "Select",
  selectedItems: "%s selected",
  settings: "Settings",
  share: "Share",
  start: "Start",
  timeLeft: "Time left",
  today: "Today",
  tryAgain: "Try again",
  undefined: "Undefined",
  upTo: "up to",
  user: "User",
  users: "Users",
  view: "View",
  exceptions: {
    invalidParam: "Field %s is invalid",
    requiredParam: "Field %s is required",
    immutableParam: "You can't update the field %s",
    invalidValue: "The value of field %s is invalid",
    greaterThan: "The value of field %s must be greater than %s",
    greaterThanOrEqual:
      "The value of field %s must be greater than or equal to %s",
    lessThan: "The value of field %s must be less than %s",
    lessThanOrEqual: "The value of field %s must be less than or equal to %s",
    betweenValues: "The value of field %s must be between %s and %s",
    lengthString: "The length of field %s must be equal to %s",
    maxAndMinLengthString: "The length of field %s must be between %s and %s",
    maxnLengthString: "The length of field %s must be less than %s",
    minLengthString: "The length of field %s must be greater than %s",
    mustBeInteger: "The value of field %s must be a integer number",
    onlyNumbers: "The value of field %s must only have numbers",
    invalidDate: "Invalid date",
    invalidEmail: "Invalid Email",
    invalidCPF: "Invalid CPF number",
    invalidUrl: "Invalid URL",
    invalidCredentials: "Invalid username and/or password.",
    networkError: "Internet connection failure!",
    auth: {
      "login-error": "It was unable to login with the information provided.",
      "register-error":
        "It was unable to register with the information provided.",
      "password-reset-error": "It was unable to send the password reset email.",
      "account-exists-with-different-credential":
        "Account exists with different authentication credential.",
      "invalid-email": "Invalid e-mail!",
      "email-already-in-use": "E-mail already in use!",
      "user-not-found": "User was not found!",
      "wrong-password": "The combination of email and password is not valid!",
      "internal-error": "Internal error! Please contact our support.",
      "network-request-failed":
        "Network failure! Please make sure your network is connected correctly.",
      "too-many-requests":
        "Login blocked by too many wrong attempts! Please try again later.",
      "requires-recent-login":
        "This action requires a recent login! Log out and log back in to this account.",
      "user-disabled": "User disabled! Please contact your administrator.",
      "invalid-user":
        "User without Access permission! Please contact your administrator.",
    },
    contract: {
      invalidUserShared:
        "The contract can only be shared with at least one valid User.",
      invalidTaxes: "Taxes must contain numerical values.",
      invalidDate: "The date cannot be greater than the current date",
      coverNotFound: "Cover image not found on path %s.",
    },
    megaIntegration: {
      networkError:
        "Failed to connect to the Mega API! \nCheck your internet connection and that the configured URL is correct.",
      invalidCredentials:
        "Failed to connect to the Mega API! \nInvalid username and/or password.",
      userNotFound:
        "User '%s' not found or wrong password! \nCheck if your password is correct and if your user is correctly registered in ERP Mega.",
      userBlocked:
        "User '%s' is blocked! \nAccess ERP Mega to unlock your user.",
      noAccessPermission:
        "User '%s' does not have permission to access module 'API'! \nAccess ERP Mega to change your user's permission.",
      quotationNotFound: "No quotation of the %s index found for the date %s.",
      invalidTenantId: "Tenant ID is invalid.",
    },
  },
  fields: {
    additive: "Additive",
    apportioning: "Apportioning",
    apportionmentValue: "Apportionment value",
    balance: "Balance",
    billing: "Net value",
    branch: "Branch",
    cancellation: "Cancellation",
    city: "City",
    client: "Customer",
    code: "Code",
    codeWBS: "Code",
    codItem: "Item code",
    contract: "Contract's Name",
    contractBalance: "Contract's Balance",
    contractDate: "Contract's creation date",
    contractValue: "Contract's value",
    costCenter: "Cost Center",
    county: "Count",
    createdDate: "Created Date",
    customer: "Customer",
    date: "Date",
    description: "Description",
    discountsTotal: "Discounts",
    documentType: "Document Type",
    email: "E-mail",
    executionRegime: "Execution regime",
    indicator: "Indicator",
    installment: "Installment",
    installmentNumber: "Installment %s",
    item: "Item",
    location: "Location",
    materialUsed: "Material Used",
    maturity: "Maturity",
    measured: "Measured value",
    name: "Name",
    newCode: "New code",
    paymentCondition: "Payment Condition",
    percentage: "Percentage",
    period: "Period",
    project: "Project's Name",
    projectErp: "Project",
    quantity: "Quantity",
    readjustimentDate: "Readjustiment date",
    readjustimentPercentual: "Readjustment percentage",
    receivableTotal: "Retention and Advances",
    status: "Status",
    taxesTotal: "Taxes",
    title: "Title",
    total: "Total",
    totalValue: "Total Value",
    type: "Type",
    unit: "Unit",
    unitCost: "Unit Value",
    unitCostShort: "Unit Value",
    unitCostWithCurrency: "Unit Cost ($)",
    value: "Value",
  },
  login: {
    title: "Enter on Rubk",
    startNow: "Start now",
    goToLogin: "Go to Login",
    dontHaveAnAccount: "Don't have an account?",
    alreadyHaveAnAccount: "Already have an account?",
    forgotPassword: "Forgot your password?",
    error: "It was unable to login with the information provided.",
    newSession: "A new session has been opened with your user.",
    register: {
      title: "Create Rubk account",
      text: "By continuing, you are agreeing to our Terms of Service and Privacy Policy.",
      createAccount: "Create account",
      error: "It was unable to register with the information provided.",
    },
    resetPassword: {
      emailSent: "Your password recovery email has been sent!",
      emailErrorSent: "It was unable to send your recovery email.",
    },
  },
  kanban: {
    title: "My contracts",
    tab1: "Contracts (%s)",
    tab2: "Dashboard",
    search: "Search contract",
    addContract: "New contract",
    shareModal: {
      title: "Share Contract",
      addEmails: "Add one or more user emails",
      addAnother: "Add another user",
      success: "Successfully shared contract!",
    },
    status: {
      aguardando: "Waiting Start",
      andamento: "In Progress",
      paralisado: "Stopped",
      concluido: "Done",
      arquivado: "Archived",
    },
    updateCoverError: "Error updating cover image: %s",
    ordering: "Ordering",
    filterByStatus: "Filter by status",
    sortFields: {
      project: "Project",
      created_date: "Creation date",
      status: "Status",
      total: "Contract value",
      percentual: "% invoiced",
    },
    saveFilterStatusError: "Error when saving filter by status: %s",
  },
  dashboard: {
    contracts: "Contracts",
    billing: "Billing",
    measurements: "Month-by-month measurements",
    oneContract: "1 contract",
    nContracts: "%s contracts",
    lookerTitle: "Dashboard - Billing",
    measureStatus: {
      andamento: "In progress",
      aguardando: "Awaiting approval",
      aprovada: "Approved",
      faturada: "Invoiced",
    },
    loadError: "Error loading chart data: %s",
    select: "Select",
    byDate: "By date",
    byStatus: "By status",
    byProject: "By project",
    filterByDate: "Filter by date",
    clearFilters: "Clear filters",
    emptyTableTitle: "No projects were found with the above filters.",
    emptyTableSubtitle:
      "Adjust date or status filters, or search for another project.",
    fields: {
      project: "Project",
      contract: "Contract",
      client: "Client",
      location: "Location",
      createdAt: "Creation date",
    },
  },
  project: {
    contractNotFound: "Sorry, we could not find this contract!",
    menu: {
      importSection: {
        title: "Import and Export",
        import: "Import contract",
      },
      parameters: {
        title: "Parameters",
        retention: "Technical retention",
        discounts: "Discounts",
        taxes: "Taxes",
        advances: "Advances",
        measurementReadjustment: "Global readjustment",
      },
      settings: {
        title: "Contract Settings",
        readjustments: "Readjustments",
        addsAndCancels: "Amendment and cancellations",
        historic: "Historic",
        occurrence: "Occurrence",
        link: "Link executive budget",
        file: "File contract",
        edit: "Edit contract",
        delete: "Delete contract",
      },
      settingsMeasurement: {
        title: "Measurement Settings",
        sendToBilling: "Send to Billing",
        delete: "Delete measurement",
        export: "Export measurement",
        occurrences: "Occurrences",
        recalculate: "Recalculate",
        import: "Import measurement",
        attachFiles: "Attach files",
      },
    },
  },
  importation: {
    modeFile: {
      step1: "Choose a File",
      step2: "Parameters",
      step3: "Field configuration",
      step4: "Customization",
      stepAtt: "Attachments",
      subtitle1: "Select a file to import",
      subtitle2: "Configure and set parameters",
      subtitle3: "Associate the file columns with the contract columns",
      subtitle4: "Create custom properties for your contract",
      subtitleAtt: "Attach files to imported additives",
      newProperty: "New Property",
      fileCaption1:
        "To optimize importing, leave your budget in a file with just one tab. Only ",
      fileCaption2: " and ",
      fileCaption3: " formats are accepted.",
      tab: "Tab",
      line: "Line",
      startRow: "Line that starts the data",
      finalRow: "Line that ends the data",
    },
    contract: {
      title: "Contract import",
      processingMessage:
        "You can wait or close this tab and come back later when the contract is ready.",
      processedMessage:
        "Your contract is now ready to be accessed and configured.",
      alreadyImported:
        "This contract has already been imported! To import a new spreadsheet create a new contract.",
      status: {
        preparing: "Preparing to import...",
        uploading: "We are important your contract...",
        file_uploaded: "We are important your contract...",
        upload_error: "Error on uploading file to server!",
        "processing data": "We are important your contract...",
        "processed data": "We are important your contract...",
        processing: "We are important your contract...",
        saving: "We are important your contract...",
        processed: "Contract imported successfully!",
        error: "An error occurred while importing contract!",
      },
    },
    additive: {
      title: "Add in bulk",
      processingMessage:
        "You can wait or close this tab and come back later when the additives are ready.",
      processedMessage:
        "You can check the imported additives in your contract.",
      status: {
        preparing: "Preparing to import...",
        uploading: "We are important your additives...",
        file_uploaded: "We are important your additives...",
        upload_error: "Error on uploading file to server!",
        "processing data": "We are important your additives...",
        "processed data": "We are important your additives...",
        processing: "We are important your additives...",
        saving: "We are important your additives...",
        processed: "Additives imported successfully!",
        error: "An error occurred while importing additives!",
      },
    },
    measurement: {
      title: "Import measurement",
      measureBy: "Measure with",
      processingMessage:
        "You can wait or close this tab and come back later when the measurement are ready.",
      processedMessage: "You can check the imported measurement.",
      status: {
        preparing: "Preparing to import...",
        uploading: "We are important your measurement...",
        file_uploaded: "We are important your measurement...",
        upload_error: "Error on uploading file to server!",
        "processing data": "We are important your measurement...",
        "processed data": "We are important your measurement...",
        processing: "We are important your measurement...",
        saving: "We are important your measurement...",
        processed: "Measurement imported successfully!",
        error: "An error occurred while importing measurement!",
      },
    },
    errorOnSchedule:
      "Please check that the fields are all filled in with correct information and try to import again.",
    errorOnProcess:
      "Please check that the spreadsheet data is correct and try importing again.",
    notFound: "not found",
    emptyWorksheet: "Empty worksheet",
    yourBudget: "your budget",
    yourAdditives: "your additives",
    theMeasurement: "the measurement",
    errors: {
      "Quantity must be a numerical value":
        "Quantity must be a numerical value",
      "UnitCost must be a numerical value":
        "UnitCost must be a numerical value",
      "Total must be a numerical value": "Total must be a numerical value",
      "Percentage must be a numerical value":
        "Percentage must be a numerical value",
      "value not found in the description column":
        "value not found in the description column",
      "value not found in the codeWBS column":
        "value not found in the codeWBS column",
      "Mandatory parameter field": "Mandatory parameter field",
      "Mandatory property [name] in field not found":
        "Mandatory property [name] in field not found",
      "Mandatory property [column] in field not found":
        "Mandatory property [column] in field not found",
      "Contract line already exists": "Contract line already exists",
      "Parent line not found": "Parent line not found",
      "Parent line is not a stage": "Parent line is not a stage",
      "Contract line not found": "Contract line not found",
      "Value less than zero": "Value less than zero",
      "Value greater than the balance": "Value greater than the balance",
      "Invalid codeWBS": "Invalid code",
      "No data to import": "No data to import",
    },
  },
  contract: {
    label: "Contract",
    integration: "Integration",
    newContractTitle: "Create a new contract",
    editContractTitle: "Edit contract",
    deleteContractTitle: "Delete contract",
    deleteMessage:
      "Are you sure you want to delete this contract? This action cannot be undone later.",
    deleteSuccess: "Contrato deletado com sucesso!",
    descriptionChange: "Description change",
    descriptionChangeMessage:
      "Do you want to save changes made to the description?",
    status: "Contract Status",
    executionRegime: {
      global: "Global Contracting",
      unitPrice: "Unit Price",
    },
    executiveBudget: {
      title: "Link executive budget",
      updated: "Budget linked successfully!",
      removed: "Link with budget removed successfully!",
      error: "Error linking budget to contract!",
      fields: {
        branch: "Select branch",
        budget: "Select executive budget",
      },
    },
    errors: {
      fetchData: "It was not possible to load data of Mega ERP.",
      authentication: "It was not possible to authenticate.",
      client: "It was not possible to find the customer.",
      branch: "It was not possible to get the branches.",
      paymentCondition: "It was not possible to get the payment conditions.",
      documentType: "It was not possible to get the document types.",
      budget: "It was not possible to get the budgets.",
      costCenter: "It was not possible to get the cost centers.",
      projectErp: "It was not possible to get the projects.",
      productItems: "It was not possible to get items.",
      finacialIndicators:
        "It was not possible to get the financial indicators.",
      finacialIndicatorQuotation:
        "It was not possible to get the quotation of the financial indicator.",
      deleteWithMeasurement:
        "Your contract has not been deleted because there are measurements created. \nPlease delete all measurements and try again.",
      deleteShared: "The contract can only be deleted by its owner.",
      updateQuantity: "It was not possible to change the quantity",
      quantityLessThanBalance:
        "The quantity cannot be less than what has already been measured, only equal to or greater than the balance.",
      descriptionChange: "Unable to change description: %s",
    },
  },
  measurements: {
    newMeasurement: "New measurement",
    deleteMeasurementTitle: "Delete Measurement",
    deleteMeasurementContent:
      "Are you sure that you want to delete this measurement? This action cannot be undone later.",
    defaultName: "Measurement %s",
    measuremntLink: "Linked to %s",
    noLink: "No Link",
    deleted: "Measurement successfully deleted.",
    loadingTable: "Loading measurement details...",
    loadingStage: "Please, wait for this measurement to load.",
    waitForUpdate: "Measurement changes are being saved. Please wait!",
    updateFailed:
      "Unable to update measurement data!\nClick the button next to it and try again.",
    status: {
      andamento: "In progress",
      aguardando: "Waiting for approval",
      aprovada: "Approved",
      faturada: "Billed",
    },
    updateStatus: {
      saving: "Saving...",
      save: "Save!",
      error: "Error on save!",
      calculating: "Calculating...",
    },
    error: {
      notFound: "Measurement not found!",
      save: "There was an error saving the measurement.",
      delete: "There was an error deleting the measurement.",
      updateBilled: "It is not possible to edit an invoiced measurement.",
      deleteBilled: "It is not possible to delete an invoiced measurement.",
      sendToBilling: "Error sending measurement to billing.",
      noProductsToBilling:
        "No product items have been selected for billing. \nPlease select at least one product.",
      noCitiesToBilling:
        "No county items were reported for billing. \nPlease add at least one county.",
      valueGreaterThanBalance:
        "It is not possible to measure a value greater than the total amount contracted for the service.",
      invalidTotal: {
        discounts:
          "Total discounts cannot be greater than the net total of the measurement.",
        advances:
          "Total advances cannot be greater than the net total of the measurement.",
      },
      invalidDates: "Period end date cannot be less than the start date",
      billing: {
        canceled:
          "Imortation of the order in the ERP has been cancelled! \nPlease resubmit for billing or check with the person responsible for the order.",
        error:
          "An error occurred while importing the order in the ERP! \nPlease resubmit for billing or check with the person responsible for the order.",
      },
      zeroUnitValue:
        "It is not possible to measure a service without a unit value.",
    },
    table: {
      measured: "Accumulated measurement",
      measuredTotal: "Total accumulated",
      measuredCurrent: "Accumulated up to this measurement",
      current: "Current measurement",
      billing: "Balance to be measured",
      calculating: "Calculating data...",
      advancesTotal: "Advances total",
      billingsTotal: "Direct billing total",
      retentionTotal: "Retention total",
      measuredPercentual: "% measured",
      accumuledPercentual: "% accumuled",
      grossInvoiceAmount: "Invoice value",
      orderCode: "Order Document",
      invoices: "Invoice",
      serial: "Serial",
      issuanceDate: "Date of issue",
      buttonBilling: "Send to billing",
      taxes: {
        title: "Taxes",
        iss: "ISS",
        inss: "INSS",
        cofins: "COFINS",
        pis: "PIS",
        csll: "CSLL",
      },
      retentionAndAdvances: {
        title: "Retention and advances",
        retention: "Technical retention",
        advanceDiscount: "Advance discount",
      },
      discounts: {
        title: "Discounts",
        directBilling: "Direct billing",
        totalExtraordinaryDiscount: "Total extraordinary discount",
      },
      measurementInformation: {
        title: "Measurement information",
        measuredValue: "Measured value",
        readjustment: "Measurement readjustment",
      },
      otherInformation: {
        title: "Other information",
        salesDocument: "Sales document",
        balanceToMeasure: "Balance to measure",
        measuredPercent: "% measured",
        accumulatedPercentage: "% accumulated",
      },
      details: {
        orderInProgress: "Waiting to generate order document",
        invoiceInProgress: "Waiting to generate invoice",
        orderDeleted: "Order document deleted. Please resend for billing.",
        orderError:
          "Error generating orders document. Try submitting for billing again.",
      },
    },
  },
  retention: {
    title: "Configure technical retention",
    label: "Percentual",
    label2: "Base Calculation",
    success: "Technical retention successfully configured.",
    options: {
      measurementTotal: "Measured value",
      grossTotal: "Measured value - Direct billing",
    },
  },
  discounts: {
    title: "Discounts Panel",
    new: "New discount",
    billingTotal: "Balance",
    amount: "Total",
    formTitle: "New discount",
    formTitleOnEditMode: "Edit discount",
    fields: {
      quantity: "Installments quantity",
      link: "Linked to measurement",
      types: {
        discount: "Discount",
        billing: "Direct billing",
      },
    },
    types: {
      desconto: "Discount",
      faturamento: "Direct billing",
    },
    deleteModal: {
      title: "Delete discount",
      text: "Are you sure you want to delete this discount?",
    },
    linkModal: {
      title: "Link discounts",
      notFound: {
        title: "No discount registered for this contract was found!",
        subtitle:
          "To add discounts, go back to the contract section and click ",
        trail: "'Options (...) > Discounts.'",
      },
    },
    success: {
      created: "Discount successfully added.",
      updated: "Discount successfully changed.",
      deleted: "Discount successfully deleted.",
      linked: "Discount linked to measurement performed successfully!",
    },
    error: {
      totalDiff: "The installments total is different from the discount total.",
      onUpdateTotal: "Total cannot be less than the linked installments total.",
      onUpdateQuantity:
        "The quantity of installments cannot be less than the quantity of linked installments.",
      onUpdateMaturityDate:
        "The installment date cannot be less than the discount date.",
      onDeleteWithMeasurement:
        "It is not possible to delete discounts with installments linked to measurements.",
      onLinkMeasurement: "Could not link discounts!",
      noLink:
        "It is necessary to mark at least one installment to make the link.",
    },
  },
  advances: {
    title: "Advances Panel",
    new: "New advance",
    balance: "Balance",
    amount: "Amount",
    formTitle: "New advance",
    formTitleOnEditMode: "Edit advance",
    fields: {
      quantity: "Installments quantity",
      link: "Linked to measurement",
    },
    deleteModal: {
      title: "Delete advance",
      text: "Are you sure you want to delete this advance?",
    },
    linkModal: {
      title: "Link advances",
      notFound: {
        title: "No advances registered for this contract was found!",
        subtitle: "To add advances, go back to the contract section and click ",
        trail: "'Options (...) > Advances.'",
      },
    },
    success: {
      created: "Advance successfully added.",
      updated: "Advance successfully changed.",
      deleted: "Advance successfully deleted.",
      linked: "Adiantamento(s) vinculado(s) a medição com sucesso!",
    },
    error: {
      totalDiff: "The installments total is different from the advance total.",
      onUpdateTotal: "Total cannot be less than the linked installments total.",
      onUpdateQuantity:
        "The quantity of installments cannot be less than the quantity of linked installments.",
      onDeleteWithMeasurement:
        "It is not possible to delete advances with installments linked to measurements.",
      onLinkMeasurement:
        "It was not possible to link the advances to the measurement!",
      noLink:
        "It is necessary to mark at least one installment to make the link.",
    },
  },
  taxes: {
    title: "Taxes",
    success: "Taxes configured successfully.",
    fields: {
      inss: "INSS",
      iss: "ISS",
      pis: "PIS",
      cofins: "Cofins",
      csll: "CSLL",
    },
  },
  integrationSetup: {
    title: "Integration",
    configuration: "Configure",
    titleForm: "INTEGRATION CONFIGURATION",
    software: "Software",
    host: "URL da integration",
    user: "Software User",
    password: "Software password",
    tenantId: "Tenant ID",
    seeMoreConfig: "Learn how to configure correctly.",
    seeMore: "See more.",
    success: {
      updated: "Configurations successfully changed.",
    },
    error: {
      missIntegration:
        "To link an executive budget, you need to configure the integration.",
      integration: "The integration URL is invalid.",
      userAndPass:
        "Your username and/or password are incorrect. Please try again.",
      userBlock: " This user is blocked.",
      userPermission: "This user has no permission.",
      invalidTenantId: "Tenant ID is incorrect. Please try again.",
    },
  },
  measurementExport: {
    title: "Export measurement",
    format: "Format",
    itemsToExport: "Items to export",
    filterByStage: "Filter by stage(s)",
    loadMoreStages: "Load more stages",
    selectStageInfo: "Select at least one stage for export",
    typeOptions: {
      current: "This measurement",
      all: "All measurements",
      onlyMeasured: "This measurement, only what was measured",
    },
    filterOptions: {
      all: "All stages",
      filter: "Filter by stages",
    },
    loadindData: "Loading data...",
    header: {
      project: "Project",
      contract: "Contract",
      client: "Client",
      location: "Location",
      measurement: "Measurement",
      period: "Period",
    },
    bands: {
      contract: "Contract",
      accumulated: "Accumulated Measurement",
      actual: "Current Measurement",
      balance: "Balance to be measured",
    },
    footer: {
      totals: "Totals",
      advance: "Advances",
      discount: "Discounts",
      billingDiscount: "Direct Billing Discounts",
      taxes: "Taxes",
      retention: "Retention",
      contract: "Total Contract",
      billing: "Total to measure",
      invoice: "Invoice Amount",
      netTotal: "Net Value",
    },
  },
  billing: {
    title: "Send to billing ",
    steps: {
      client: "Client",
      measurement: "Measurement",
      itemSelection: "Item selection",
      resourcesByCounty: "Resources by county",
      resume: "Resume",
    },
    fields: {
      totalMeasured: "Total measured",
      billing: "Total direct billing",
      totalReceivable: "Total receivable",
    },
    autoApportioning: "Automatic apportionment",
    manualApportioning: "Manual apportionment",
    materialUsedTooltip: "No ISS or INSS is applied",
    success: "Data sent to billing successfully.",
    error: "Unable to send data to billing",
    alreadyBilled:
      "This measurement's billing has already been sent! Please select another measurement.",
    noAuth:
      "Unable to connect to ERP Mega. Please verify that your connection details are correct.",
    noItems: "No records found.",
    noResults: "No records matching the search were found.",
    noPattern: "Customer pattern not found",
    valueErrorMessage: "Value must be equal to or less than the balance",
    percentageErrorMessage:
      "Percentage must be equal to or less than the balance",
    measurementAndReadjustment: "Medição + Reajuste",
    newCounty: "New county",
    apportionmentTypes: {
      medição: "Measurement",
      reajuste: "Readjustment",
      mediçãoMaisReajuste: "Measurement + Readjustment",
    },
    salesDocument: "Sales document",
    separateReadjustment: "Separate readjustment",
  },
  indicatorsPage: {
    charts: {
      contract: {
        title: "Contract",
        chartLabel: "Indicators - Contract",
      },
      budget: {
        title: "Executive Budget",
        chartLabel: "Indicators - Executive Budget",
      },
    },
    addsAndCancels: {
      title: "Total of Additives and Cancellations",
      adds: "Additives",
      cancels: "Cancellations",
      details: "Details",
      modalTitle: "Details of Additives, Cancellations e other changes",
      otherChanges: "Other Changes",
      structured: "Code",
      description: "Description",
      quantityApplied: "Added Qty.",
      quantityCanceled: "Removed Qty.",
      totalApplied: "Total",
      date: "Date",
      userName: "User",
      descriptionBefore: "Description (BEFORE)",
      descriptionAfter: "Description (AFTER)",
      quantityBefore: "Qty. (BEFORE)",
      quantityAfter: "Qty. (AFTER)",
    },
    noLink:
      "To view cost indicators, you need to link your contract to your executive budget.",
  },
  addsAndCancels: {
    title: "Additives and Cancellations",
    formsTypes: {
      additiveRow: "Additive entire line",
      additiveQuantity: "Add quantity",
      cancellationRow: "Distract entire line",
      cancellationQuantity: "Cancel quantity",
      cancellationMass: "Cancellation mass",
    },
    qttAddHelp: "How much do you want to add?",
    qttCancelHelp: "How much do you want to distract?",
    addInBulk: "Add in bulk",
    codes: "Code(s)",
    codesHelperText: "Add multiple codes by separating them with semicolons",
    messages: {
      success: {
        additive: "Additive successfully applied.",
        cancellation: "Cancellation successfully applied.",
      },
      error: {
        additive:
          "There was an unexpected error. Please refresh the page to try again. Error: %s",
        cancellation:
          "There was an unexpected error. Please refresh the page to try again. Error: %s",
        existedCode:
          "This code already exists. Check the contract and try again.",
        inexistedCode: "Non-existent code. Check the contract and try again.",
        invalidCode: "Invalid code. Check the contract and try again.",
        invalidQuantity:
          "It is not possible to terminate as the balance is less than the amount to be terminated.",
        parentRowNotFound: "Parent line not found [%s]",
        parentRowIsNotStage: "Parent line is not a stage [%s]",
        balanceGreaterThanZero:
          "It is not possible to cancel as there are one or more lines with a balance equal to or less than zero.",
      },
    },
  },
  lineHistory: {
    title: "Details",
    totalContract: "Total contract value",
    description: "Description",
    oldDescription: "Old description",
    qtts: {
      Aditivo: "Added quantity",
      Distrato: "Canceled quantity",
      Alterado: "Updated quantity",
    },
    indicator: {
      manual: "Manual Readjustment",
      percentual: "Readjustment percentage",
      total: "Contract value after readjustment",
      balance: "Contract balance after readjustment",
    },
    types: {
      Contrato: "Original line",
      Aditivo: "Additive",
      Distrato: "Cancellation",
      Reajuste: "Readjustment",
      Alterado: "Alteration",
      AlteradaDescricao: "Description change",
    },
  },
  contractReadjustment: {
    title: "Readjustment",
    manual: "Manual Readjustment",
    contractTotal: "Contract value after readjustment",
    contractBalance: "Contract balance after readjustment",
    messages: {
      success: "Reset applied successfully.",
    },
  },
  measurementReadjustment: {
    title: "Configure measurement readjustment",
    readjust: "Readjustment amount",
    messages: {
      success: "Measurement readjustment changed successfully!",
    },
  },
  dropzone: {
    empty: "Select local file",
    dropHere: "Drop the file here...",
  },
  pagination: {
    rowsPerPage: "Lines per page:",
    backText: "Previous page",
    nextText: "Next page",
  },
  errorPages: {
    notFound: "Sorry, page not found.",
  },
  userProfile: {
    myProfile: "My profile",
    enterprise: "Enterprise",
    collaborators: "Collaborators",
    accessProfile: "Access profile",
    addProfile: "Register new profile",
    noProfileFound: "No profiles were found.",
    users: "%s user(s)",
    createProfile: "Create profile",
    thisProfileAlreadyExists:
      "This profile already exists. Please enter again.",
    profileEditedSuccessfully: "Profile edited successfully.",
    errorEditingProfile: "Error editing profile: %s",
    profileCreatedSuccessfully: "New profile created successfully.",
    errorCreatingProfile: "Error creating profile: %s",
    profileCannotBeDeleted:
      "This profile cannot be deleted as there are linked users.",
    profileDeletedSuccessfully: "Profile deleted successfully.",
    errorDeletingProfile: "Error deleting profile: %s",
    unableToChangeEmployee: "Unable to change employee access profile!! %s",
    profileDoesNotAllow: "Your profile does not allow this action",
    processes: {
      configuracoes: "Settings",
      gerar_contrato: "Generate contract",
      editar_contrato: "Edit contract",
      excluir_contrato: "Delete contract",
      gerar_aditivo: "Generate additive",
      gerar_distrato: "Generate cancellation",
      anexar_arquivos: "Attach files",
      gerar_medicoes: "Generate measurements",
      aprovar_medicoes: "Approve measurements",
      excluir_medicoes: "Delete measurements",
      criar_documento_de_venda: "Create sales document",
      indicadores: "Indicators",
    },
  },
  attachments: {
    attachFiles: "Attach files",
    uploadError: "Upload error",
    waitUpload: "Wait for the attachments to be uploaded!",
    errors: {
      uploadError:
        "An error occurred while uploading the file. Please try again.",
      removeError: "An error occurred while removing file.",
      saveError: "An error occurred while saving the attached files.",
      invalidFormat:
        "The selected file format is not supported.\nPlease choose a file in an accepted format.",
      maximumSize:
        "One or more selected files are larger than 100MB.\nChoose a smaller file to attach.",
      maximumFilesCount:
        "You have exceeded the maximum number of files that can be attached.\nPlease remove one or more files and try again.",
      invalidFile:
        "The file you are trying to attach appears to be corrupt.\nPlease check the file and try again.",
    },
  },
  exportData: {
    project: "Project",
    contract: "Contract",
    customer: "Customer",
    location: "Location",
    description: "Description",
    measurements: {
      title: "Measurements",
      total: "Measurement value",
      totals: "Totals",
      discounts: "Discounts",
      grossTotal: "Invoice Value",
      retentionAdvance: "Retention and Advance",
      taxes: "Taxes",
      netTotal: "Net Value",
      status: "Status",
      invoiceNumber: "Invoice",
      invoiceSerial: "Series",
      invoiceDate: "Emission Date",
      period: "Period",
      orderCode: "Sales Document",
      balanceToMeasure: "Balance to Measure",
      measuredPercentual: "% measured",
      accumulatedPercentual: "% accumulated",
      clientName: "Customer Name",
    },
    addsAndCancels: "Additives_and_Cancellations",
  },
};
